import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b396802"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main" }
const _hoisted_2 = {
  class: "mxa-nologin-main-explanation",
  "data-test": "desc"
}
const _hoisted_3 = { class: "mxa-nologin-main-inputgroup" }
const _hoisted_4 = { class: "mxa-nologin-main-input" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BaseInput from '@/components/common/input/BaseInput.vue'
import BaseButton from '@/components/common/button/BaseButton.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import NormalMessage from '@/components/common/screen/NormalMessage.vue'
import * as log from '@/model/util/log/Logger'
import { initDom, useTop, preauth, useErrorMsg, useNormalMsg } from '@/model/components/users/userLoginTop'
import LoginTopService from '@/components/main/nologin/LoginTopService.vue'
import NologinTitle from '@/components/main/nologin/NologinTitle.vue'

// プロパティ定義

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginTop',
  props: {
  // リダイレクト
  redirect: {
    type: String,
    default: undefined,
  },
  // ダウンロードキー
  downloadKey: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props



// 状態
const store = useStore()
const router = useRouter()
const errorState = useErrorMsg(store.state.screen.top.error)
const nomralState = useNormalMsg()
const state = useTop(props)

log.debug(`LoginTop props: ${JSON.stringify(props)}, state: ${JSON.stringify(state)}`)
// onMountedの登録
onMounted(async () => {
  log.trace('LoginTop onMounted start.')
  // 初期処理
  await initDom(state, store, router, store.state.screen.top.auth)
  log.trace('LoginTop onMounted end.')
})

// ボタン押下処理
const onclick = () => {
  log.trace(`LoginTop onClick start.`)
  // API実施して成功の場合は各画面に遷移、エラーの場合はエラーメッセージを設定
  preauth(state, store, router, errorState)
  log.trace(`LoginTop onClick end.`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NologinTitle, {
        title: _ctx.$t('body.top.title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('body.top.message')), 1),
      _createElementVNode("form", {
        action: "",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(BaseInput, {
              type: "email",
              placeholder: _ctx.$t('body.top.username.placeholder'),
              maxlength: 254,
              autocomplete: "username",
              "init-focus": true,
              "data-test": "email",
              modelValue: _unref(store).state.screen.top.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.screen.top.username) = $event)),
              onInputEnter: onclick
            }, null, 8, ["placeholder", "modelValue"])
          ])
        ]),
        _createVNode(NormalMessage, { normal: _unref(nomralState) }, null, 8, ["normal"]),
        _createVNode(ErrorMessage, { error: _unref(errorState) }, null, 8, ["error"]),
        _createElementVNode("div", null, [
          _createVNode(BaseButton, {
            loading: _unref(state).loading,
            isDisabled: _unref(state).loading,
            label: _ctx.$t('body.top.button.next.title'),
            styles: "mxa-nologin-main-button",
            onButtonClick: onclick
          }, null, 8, ["loading", "isDisabled", "label"])
        ])
      ], 32)
    ]),
    _createVNode(LoginTopService)
  ], 64))
}
}

})